import { Grid2 } from "@mui/material";
import NavigatorArrows from "../../components/NavigatorArrows";
import { createCompanyLink } from "../../pages";
import CompanyOverview from "../../components/CompanyOverview";
import MemberAreaTable from "../../components/MemberAreaTable";

import classes from './index.module.scss';

const MemberAreaContainer = ({ company }) => {
  if (!company) {
    return null
  }

  return (
    <Grid2 container className={classes.wrapper}>
      <Grid2 container size={12} className={classes.container}>
        <NavigatorArrows
          leftLink={
            {
              href: createCompanyLink(company.name),
              title: 'Company Area',
            }
          }
          rightLink={null}
        />
        <CompanyOverview company={company} />
      </Grid2>
      <MemberAreaTable company={company} />
    </Grid2>
  )
}

export default MemberAreaContainer;